"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_PERMISSIONS = void 0;
exports.USER_PERMISSIONS = {
    CONTRIBUTE: 'Contribute',
    MANAGE_USERS: 'Manage Users',
    MANAGE_CLIENT_USERS: 'Manage Client Users',
    SHARE: 'Share',
    APPROVE: 'Approve',
    MANAGE_CONTENT: 'Manage Content',
};
